import { getNodeByAttr } from "./locate";
export function getPopupPosition(node, id) {
    const eventNode = getNodeByAttr(`${id}`, node);
    if (eventNode) {
        const rect = eventNode.getBoundingClientRect();
        let placement = "horizontal";
        let left, top, height;
        if (rect.width > rect.height * 5) {
            placement = "vertical";
        }
        if (placement === "vertical") {
            left = rect.left + rect.width / 2 - 150;
            height = rect.height;
        }
        else {
            left = rect.right;
            height = 0;
        }
        top = rect.top;
        return {
            top: top,
            left,
            height,
            width: rect.width,
            placementMode: placement,
        };
    }
}
export function correctPopupPosition(pos, trueSizes) {
    let { left, top } = pos;
    const { width, height } = trueSizes;
    const nodeLeft = left - width - pos.width;
    const nodeBottom = top + height + pos.height;
    const bodyCoords = document.body.getBoundingClientRect();
    if (width + left > bodyCoords.right) {
        if (pos.placementMode === "vertical") {
            left = bodyCoords.right - width;
        }
        else {
            left = nodeLeft > 0 ? nodeLeft : bodyCoords.right - width;
        }
    }
    if (nodeBottom > bodyCoords.top + bodyCoords.height) {
        top = top - trueSizes.height;
    }
    return { ...pos, left, top };
}
//# sourceMappingURL=popupPosition.js.map